import { render, staticRenderFns } from "./SomethingWentWrong.vue?vue&type=template&id=5c585f3e&scoped=true"
import script from "./SomethingWentWrong.vue?vue&type=script&lang=js"
export * from "./SomethingWentWrong.vue?vue&type=script&lang=js"
import style0 from "./SomethingWentWrong.vue?vue&type=style&index=0&id=5c585f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c585f3e",
  null
  
)

export default component.exports